import React from "react";
import s from './img.module.scss';

export const Img = (props) => {

  return(
    <picture>
      {props.webp && (
        <source srcSet={props.webp} type="image/webp" />
      )}
      <img className={s.img} src={props.png} alt="image" />
    </picture>
  )
}